<template>
  <div class="article-sort cell"> 
    <ArticleSort v-if="!hideCategories" :categories="cats" :preselectedCats="preselectedCats" v-on:activeCategoryChanged="onCategoryChanged"></ArticleSort>
    <clip-loader :loading="loading" color="#009d9b" size="32px"></clip-loader>
    <transition-group name="list" tag="div" class="grid-x grid-margin-x article-pick-wrapper">
      <div v-for="(post) in posts" :key="post.id" class="list-item cell small-6 medium-4 large-4">
        <a :href="post.url" :title="post.title" :style="getThumb(post)" class="article-thumbnail" xv-if="post.thumbnail">
          <span v-if="post.category" class="article-category-name">{{post.category.name}}</span>
          <span v-if="post.excerpt" class="article-pretext">{{post.excerpt}}</span>
        </a>
        <span class="article-publish-date" v-html="post.date"></span>
        <h3>
        <a :href="post.url" :title="post.title" class="article-link" v-html="post.title"></a>
      </h3>
      </div>
    </transition-group>
    <div class="button-container text-center" v-if="showLoadMore && !disableLoadMore">
      <a @click="loadMore" class="button button--bordered" v-html="lang.loadMore"></a>
    </div>
  </div>
</template>
<script>
var dayjs = require('dayjs');
import ArticleSort from "./ArticleSort";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
export default {
  components: { ArticleSort, ClipLoader },
  data() {
    return {
      posts: [],
      cats: [],
      postsPerPage: 4,
      offset: 0,
      showLoadMore: false,
      disableLoadMore: true,
      hideCategories: false,
      selectedCats: [],
      preselectedCats: -1,
      baseUrl: window.BASE_URL,
      queryBase: window.BASE_URL + "/wp-json/wp_query/args/",
      queryCat: window.BASE_URL + "/wp-json/mp/categories",
      loading: true
    };
  },
  mounted: function() {
    this.listingType = this.$el.getAttribute("data-posttype");
    this.postsPerPage = parseInt(this.$el.getAttribute("data-perpage"), 10);
    this.disableLoadMore = this.$el.hasAttribute("data-disableshowmore");
    this.hideCategories = this.$el.hasAttribute("data-hidecategories");
    this.preselectedCats = parseInt(this.$el.getAttribute("data-category"), 10);
    if (this.preselectedCats > 0) {
      this.preselectedCats = [this.preselectedCats];
    }
    if (this.preselectedCats.length > 0) {
      this.selectedCats = this.preselectedCats;
    }

    //Check if hash contains some cats
    let hash = document.location.hash.toString();
    if (hash.indexOf("#!") === 0) {
      let spl = hash.split("#!");
      if (spl.length == 2) {
        let ids = spl[1].split(",");
        let intIds = [];
        for (let i = 0; i < ids.length; i++) {
          intIds.push(parseInt(ids[i], 10));
        }
        this.selectedCats = intIds;
      }

    }

    Promise.all([this.fetchPosts(), this.fetchCats()]).then(
      ([postData, categoryData]) => {
        let catObjects = this.createCats(categoryData);
        catObjects.unshift({ name: "Kaikki", id: -1 });
        this.cats = catObjects;
        this.posts = this.createPosts(postData, categoryData);
        this.loading = false;
        window.Vue.nextTick(() => {
          this.setActiveInputs();
        });
      }
    );

  },
  watch: {},
  computed: {

    lang() {
      return window.LANG;
    },

    postQuery() {
      let query =
        this.queryBase +
        "?_embed&post_type=" +
        this.listingType +
        "&posts_per_page=" +
        this.postsPerPage +
        "&" +
        "offset=" +
        this.offset;
      if (window.LANGCOUNT > 0) {
        query +=
          "&lang=" +
          window.SITE_LANG;
      }

      query =
        this.selectedCats.length == 0 ?
        query :
        query + "&cat=" + this.checkGeneralCat(this.selectedCats);

      return query;
    },
    perPage() {
      return this.postsPerPage;
    }
  },
  methods: {

    checkGeneralCat(arr) {
      if (arr.indexOf(-1) >= 0) {
        return -1;
      } else {
        return arr;
      }
    },

    setActiveInputs() {

      let vm = this;

      // History/splits
      let hash = document.location.hash.toString();
      // if (hash.indexOf("#!") === 0) {
      //   let spl = hash.split("#!");
      //   if (spl.length == 2) {
      //     let indexes = spl[1].split(",");
      //     indexes.forEach((val) => {
      //       let selector = "input[value='" + val + "']";
      //       let input = document.querySelectorAll(selector);
      //       log("input", selector, vm.$el, input, input.classList);
      //       if (input[0]) {
      //         if (input[0].classList.contains('active')) {
      //           input[0].classList.remove('active');
      //         } else {
      //           input[0].classList.add('active');
      //         }
      //       }
      //     });
      //   }
      // }
    },

    getThumb(post) {
      if (post.thumbnail) {
        return "background-image:url('" + post.thumbnail + "')";
      } else {
        return "background-image:url('" + window.THEME_LINK + "/resources/assets/images/default-article-thumbnail.png" + "')";
      }
    },
    createPosts(postData, cats) {
      let posts = [];
      postData.forEach(post => {
        let simplePost = this.createPostObject(post, cats);
        posts.push(simplePost);
      });
      return posts;
    },
    createCats(catData) {
      let cats = [];
      catData.forEach(cat => {
        let simpleCat = {
          name: cat.name,
          id: cat.term_id,
          term_id: cat.term_id
        };
        cats.push(simpleCat);
      });
      return cats;
    },
    createPostObject(post, cats) {
      let cat = cats.find(c => c.term_id == post.categories[0]);
      let thumb = post._embedded['wp:featuredmedia'];
      if (thumb && thumb[0] && thumb[0].media_details && thumb[0].media_details.sizes && thumb[0].media_details.sizes.medium_large) {
        thumb = thumb[0].media_details.sizes.medium_large.source_url
      } else if (thumb && thumb[0] && thumb[0].media_details && thumb[0].media_details.sizes && thumb[0].media_details.sizes.large) {
        thumb = thumb[0].media_details.sizes.large.source_url
      } else {
        thumb = window.THEME_LINK + "/static/images/vasemmisto-dummy.jpg";
      }
      return {
        id: post.id,
        date: dayjs(post.date).format("D.M.YYYY"),
        title: post.title.rendered,
        category: cat,
        excerpt: post.content_pretext,
        url: post.link,
        thumbnail: thumb
      };
    },
    loadMore() {
      this.offset += this.postsPerPage;
      this.fetchPosts().then(postData => {
        let posts = this.createPosts(postData, this.cats);
        this.posts = this.posts.concat(posts);
      });
    },
    fetchPosts() {

      return fetch(this.postQuery)
        .then(response => {
          let totalPosts = response.headers.get("X-WP-Total");
          this.showLoadMore =
            this.offset + this.postsPerPage < totalPosts ? true : false;
          return response.json();
        })
        .catch(error => console.error("error: " + error));
    },
    fetchCats() {
      return fetch(this.queryCat + "?lang=" + window.SITE_LANG)
        .then(response => {
          return response.json();
        })
        .catch(error => console.error("error: " + error));
    },
    onCategoryChanged(ids) {
      // log("oncategorychanged", id);
      // let selectedInputs = this.$el.querySelectorAll("input[type='checkbox']:checked");

      // let selectedValues = [];
      // if (selectedInputs.length) {

      //   selectedInputs.forEach((elem) => {
      //     selectedValues.push(parseInt(elem.value,10));
      //   });
      //   this.selectedCats = selectedValues;
      //   log("selectedValues", selectedValues);
      //   // document.location.hash = "#!" + selectedValues.join(",");
      // } else {
      //   // document.location.hash = "";
      //   // this.selectedCats = [];
      // }

      this.selectedCats = ids;

      this.loading = true;
      this.fetchPosts().then(postData => {
        this.posts = this.createPosts(postData, this.cats);
        this.loading = false;
        window.Vue.nextTick(() => {
          this.setActiveInputs();
        })
      });
    },
    finLang() {
      if (window.SITE_LANG == "fi") {
        return true;
      }
    }
  }
};

</script>
<style lang="scss" scoped>
.list-enter-active {
  transition: all 750ms ease 450ms;
}

.list-leave-active {
  transition: all 750ms ease;
}

.list-enter,
.list-leave-to

/* .list-leave-active below version 2.1.8 */
  {
  opacity: 0;
  transform: translateY(30px);
}

</style>
